import { ImgHTMLAttributes } from "react";

/**
 * <Picture> — serves AVIF → WebP → fallback in a single <picture> element.
 *
 * The <picture> wrapper mirrors `className` so grid/flex layouts still work,
 * and the inner <img> receives it too (so `object-cover`, `rounded-*`, etc.
 * apply correctly).
 */

export type PictureSources = Record<string, string> | undefined;

type Props = ImgHTMLAttributes<HTMLImageElement> & {
  avif?: string;
  webp?: string;
  sources?: PictureSources;
  wrapperClassName?: string;
};

export function Picture({
  avif,
  webp,
  sources,
  alt = "",
  loading = "lazy",
  decoding = "async",
  className,
  wrapperClassName,
  ...img
}: Props) {
  const avifSrc = avif ?? sources?.avif;
  const webpSrc = webp ?? sources?.webp;
  return (
    <picture className={wrapperClassName ?? className}>
      {avifSrc && <source type="image/avif" srcSet={avifSrc} />}
      {webpSrc && <source type="image/webp" srcSet={webpSrc} />}
      <img {...img} alt={alt} loading={loading} decoding={decoding} className={className} />
    </picture>
  );
}

export default Picture;
